angular.module('iqxCore')
.service('nvd3Svc', function (ApiSvc) {
	var svc=this

	function eu(s){
		return encodeURIComponent(s)
	}
	
	function makeTarget(id,spec){
		return 'grphData'+id+'_'+spec.table  // Temporary target for fetch
	}
	
	svc.fetchStat=function(scope,target,spec){
		var qTiming=''
		if (spec.timing){
			qTiming='&timing=' + eu(spec.timing)
			if (spec.range){
				qTiming+='&range=' + eu(spec.range)
			} else {
				qTiming+='&timefrom=' + eu(moment(spec.timeFrom).format('YYYY-MM-DD'))
				qTiming+='&timeto=' + eu(moment(spec.timeTo).format('YYYY-MM-DD'))
			}
			qTiming+='&granularity=' + eu(spec.granularity)
		}
		var query='table=' + eu(spec.table) + '&statistics=' + eu(spec.statistic) + qTiming
		if (spec.grouping){
			query+='&grouping='+eu(spec.grouping)
		}
		if (spec.filters){
			query+='&filters='+eu(JSON.stringify(spec.filters))
		}
		spec.statistic=spec.statistic.replace(/[ ]/g,'-')
		return ApiSvc.fetch(scope,{fetchAPI:'olap/graphdata?'+query, fetchTarget:target, multiRow:true, dateFields:['Timing'], numberFields:[spec.statistic]})
	}

	svc.sparkLine=function(scope,id,spec){
		var target=makeTarget(id,spec)
		svc.fetchStat(scope,target,spec)
		.then(function(){
			if(scope[target].length>0){
				var chData=[]
				angular.forEach(scope[target],function(value){
					chData.push({x:value.Timing, y:value[spec.statistic]})
				})
				scope[target]=undefined  // Free temporary memory
				nv.addGraph({
					generate: function() {
						var chart = nv.models.sparklinePlus()
							.showLastValue(false)
							.showMinMaxPoints(false)
							.xTickFormat(d3.time.format('%d/%m/%Y'))
							.yTickFormat(d3.format('d'))
						d3.select('#'+id)
							.datum(chData)
							.call(chart)
						return chart
					}
				})
			}else{
				scope.noData = true
			}			
		})
	}
	
	svc.pieChart=function(scope,id,spec){
		var target=makeTarget(id,spec)
		svc.fetchStat(scope,target,spec)
		.then(function(){
			if(scope[target].length>0){
				var chData=[]
				angular.forEach(scope[target],function(value){
					chData.push({x:value.Grouping, y:value[spec.statistic]})
				})
				scope[target]=undefined  // Free temporary memory
				nv.addGraph({
					generate: function() {
							var chart = nv.models.pieChart()
								.showLegend(false)
								.hideOverlapLabels(true)
								.valueFormat(d3.format('d'))
							d3.select('#'+id)
								.datum(chData)
								.call(chart)
							return chart
						}
					})
				}else{
					scope.noData = true
				}
			})
	}
	
	svc.fetchHomePageGraphics=function(scope){
		return ApiSvc.fetch(scope,{fetchAPI:'callresult/NetDashboardObjects?pHomePage=1',fetchTarget:'homePageGraphicsTmp',multiRow:true})
		.then(function(){
			scope.graphics={sparklines:[],pies:[]}
			angular.forEach(scope.homePageGraphicsTmp,function(g){
				try{
					var descrip=JSON.parse(g.Descriptor)
					var spec=descrip.queries[0] //homePage graphics use only a single query
					spec.statistic=spec.statistics[0] // and a single statistic
					delete spec.statistics
					if (g.Type=='Analysis Chart'){
						spec.grouping=descrip.grouping
						scope.graphics.pies.push({id:g.DashboardObjectID,title:g.Title,spec:spec})
					} else if (g.Type=='Performance Chart'){
						if (spec.grouping) {delete spec.grouping} // sparklines are a single line
						spec.range=descrip.range
						spec.granularity=descrip.granularity
						scope.graphics.sparklines.push({id:g.DashboardObjectID,title:g.Title,spec:spec})
					}
				} catch(err) {
					// If JSON or contained data is invalid, ignore
				}
			})
			delete scope.homePageGraphicsTmp
		})
	}


})     
		
.directive('iqxPiechart', function () {
	return {
		restrict: 'E',
		scope: {piechart: '='},
		template: `<svg id="{{piechart.id}}" class="piechart" style="display:block; margin: auto; height: 250px; width: 250px; font-size: 14px; " ng-show="!noData"></svg>
		<div ng-show="noData" style="padding:30px; opacity:0.3" class="text-center"><i class="fas fa-chart-pie fa-4x"></i><h5>There is no matching data.</h5></div>`,
		controller: function($scope, nvd3Svc) {
			nvd3Svc.pieChart($scope,$scope.piechart.id,$scope.piechart.spec)
			
		}
	}
})      